/** @flow */

import React from "react";
import classNames from "classnames";
import "./links-container.style.scss";

type Props = $Exact<{
  title?: string,
  items: Array<
    $Exact<{
      label: string,
      link?: string,
      hidden?: boolean,
      onClick?: () => void,
    }>,
  >,
  className?: string,
  itemClassName?: string,
}>;

export const LinksContainer = (props: Props) => {
  const handleLinkClick = item => () => {
    if (item.onClick) {
      item.onClick();
    }
  };

  return (
    <div
      className={classNames(
        "links-container d-flex align-items-center justify-content-center",
        props.className,
      )}
    >
      {props.title ? (
        <div className={classNames("links-title", props.itemClassName)}>{props.title}</div>
      ) : null}
      {props.items
        .filter(item => !item.hidden)
        .map((item, index) => (
          <a
            onClick={handleLinkClick(item)}
            key={`${item.label}${index}`}
            className={classNames("links-item", props.itemClassName)}
            href={item.link}
          >
            {item.label}
          </a>
        ))}
    </div>
  );
};

export default LinksContainer;
